// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.sticky-btn {\n  position: fixed;\n  z-index: 10;\n  top: 52px;\n}\n", ""]);
// Exports
module.exports = exports;
